




























































import { gridSize } from '@/theme/constants';

import Colorable from '@/mixins/colorable';
import mixins from '@/utils/mixins';
import { CSSProperties } from '@/components/types';

export default mixins(Colorable).extend({
  name: 'ALPageHeader',

  props: {
    id: { type: String },
    truncateTitle: { type: Boolean, default: () => false },
    disableTitleStyles: { type: Boolean, default: () => false },
    fluid: { type: Boolean, default: () => false },
    noPadding: { type: Boolean, default: () => false },
    noMargin: { type: Boolean, default: () => false },

    title: { type: String, default: () => '' },
    subTitle: { type: String, default: () => '' },

    color: { type: String, default: () => 'background' }
  },

  computed: {
    alPageHeaderContainerClasses(): string {
      if (this.noPadding) return 'pa-0';
      return 'py-1 px-4 px-sm-6 px-md-8 px-lg-10';
    }
  }
});
